import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { track } from '../../utils/analytics';
import { afterSignInPath } from '../../utils/pendingInvite';
import { Box, CircularProgress, Typography } from '@mui/material';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const { getCurrentUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      // Check for error in URL
      const params = new URLSearchParams(window.location.search);
      const error = params.get('error');

      if (error) {
        console.error('OAuth error:', error);
        navigate('/login?error=' + error);
        return;
      }

      // Cookies are already set by backend
      // Just fetch the current user and redirect
      try {
        const user = await getCurrentUser();
        // OAuthCallback is only reached via a genuine OAuth redirect, never on app reload, so this
        // is the right place to count a real sign-in without inflating on session hydration.
        track('signed_in', { provider: user?.provider || 'oauth', method: 'oauth' });
        navigate(afterSignInPath('/'));
      } catch (err) {
        console.error('Failed to get user after OAuth:', err);
        navigate('/login?error=callback_failed');
      }
    };

    handleCallback();
  }, [getCurrentUser, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Completing sign in...
      </Typography>
    </Box>
  );
};

export default OAuthCallback;
